export default league => league.sport_name === 'soccer';
